module.exports = __webpack_public_path__ + "img/4.701a7f21.png";